<div class="content-container" role="main">
  <app-header />
  <div class="card">
    <div class="illustration">
      <img ngSrc="assets/images/disconnection.svg" width="250" height="183" alt="Betaalverzoek niet gevonden" priority />
    </div>
    <div class="text">
      <h2>Oeps! Dit betaalverzoek werkt helaas niet...</h2>
      <p>
        Misschien is de link verouderd of niet helemaal juist.<br />
        Probeer het nog eens of ga naar <a href="https://www.knab.nl/contact" target="_blank" rel="noopener noreferrer">knab.nl/contact</a>.
      </p>
    </div>
  </div>
</div>
